import * as angular from "angular";
import {IController} from "angular";

export class omsOrdersTableRowTasksCtrl implements IController {

  columns: any;
  order: any;

  constructor() {
  }

  $onInit() {
  }


}

angular
  .module('bringoz.admin.oms')
  .component('omsOrdersTableRowTasks', {
    bindings: {
      order: '<',
      columns: '<?'
    },
    template: require('./oms-orders-table-row-tasks.html').default,
    controller: omsOrdersTableRowTasksCtrl
  });
